import React from 'react'
import { Link, Box, Divider } from 'theme-ui'

const styles = {
  link: {
    display: `inline-flex`,
    color: `heading`,
    fontWeight: `medium`,
    ':visited': {
      color: `heading`
    },
    svg: {
      fill: `omegaDarker`,
      height: 24,
      ml: 2
    }
  }
}

const PoweredByGatsby = () => (
  <Box>
    <Link
      variant='mute'
      target='_blank'
      title='Earl Grey'
      href='https://en.wikipedia.org/wiki/Earl_Grey_tea'
      rel='noopener'
      sx={styles.link}
    >
      Powered By Earl Grey
    </Link>
    <Divider space='0' />
    <Link
      variant='mute'
      target='_blank'
      title='Flat Icon'
      href='https://www.flaticon.com/'
      rel='noopener nofollow'
      sx={styles.link}
    >
      Icons made by Freepik.com from Flaticon.com
    </Link>
  </Box>
)

export default PoweredByGatsby
